export default __webpack_public_path__ + "static/media/card-image13.99c37b7c.png";